import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useJourneyPlannerTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
